export const SET_FARM = 'SET_FARM';

export const FETCH_FARMS = 'FETCH_FARMS';

export const FETCH_FARM_SUCCESS = 'FETCH_FARM_SUCCESS';